<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="icon ion-chatbubbles"></i>
        <div class="mg-l-20">
          <h4>{{$t("mall.咨询管理")}}</h4>
        </div>
      </div>
      <div class="tx-right">
        <!-- <button class=" btn btn-success">添加仓库</button> -->
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30">
      <div class="clear-key">
        <a v-show="distributorName" href="javascript:;" class=" mg-r-15" @click="clearKey('name')">
          {{$t("mall.供应商名：")}}
          <span class="mg-r-10">{{distributorName}}</span>
          <i class="fa fa-close"></i>
        </a>
        <a v-show="status" href="javascript:;" class=" mg-r-15" @click="clearKey('status')">
          {{$t("mall.状态：")}}
          <span class="mg-r-10">{{msgStatus[status]}}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["msgStatus", "status", "distributorName"],
  methods: {
    clearKey(type){
       this.$emit('clearKey', type)
    }
  },
}
</script>
